import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SortOptions } from "@/shared/components/table/GenericTable";
import {
  AdminOrganizationControllerFindManyQueryParams,
  Nullable,
} from "service";

export type OrganizationSortField = NonNullable<
  AdminOrganizationControllerFindManyQueryParams["sort"]
>;

export interface FilterState {
  sortOptions: Nullable<SortOptions>;
}

export type UpdateFilter = <K extends keyof FilterState>(
  key: K,
  value: FilterState[K],
) => void;

const useOrganizationsFilters = () => {
  const [params, setSearchParams] = useSearchParams();

  const [filters, setFilters] = useState<FilterState>({
    sortOptions: params.get("sortBy")
      ? {
          sortBy: params.get("sortBy") || "",
          direction: (params.get("direction") || "") as "asc" | "desc",
        }
      : null,
  });

  const updateFilter: UpdateFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const queryParams: AdminOrganizationControllerFindManyQueryParams = {
    limit: 1000,
    ...(filters.sortOptions?.sortBy && {
      sort: filters.sortOptions.sortBy as OrganizationSortField,
    }),
    ...(filters.sortOptions?.direction && {
      order: filters.sortOptions.direction,
    }),
  };

  return { filters, updateFilter, queryParams, setSearchParams };
};

export default useOrganizationsFilters;
